const React = require('react')
const PropTypes = require('prop-types')
const styles = require('./dropdown.css')
const Link = require('@npm/spiferack/link')

class Dropdown extends React.PureComponent {
  render() {
    const {text, heading, items, onClick} = this.props
    return (
      <div className={styles.dropdown}>
        <input className={styles.dropdownToggle} type="text" />
        <div className={styles.dropdownText}>{text}</div>
        <ul className={styles.dropdownContent}>
          {heading && (
            <li>
              <span className={styles.header}>{heading}</span>
            </li>
          )}
          {items &&
            items.map(item => {
              return onClick ? (
                <li key={item.key}>
                  <a href={item.href} className={styles.itemLink} onClick={onClick}>
                    {item.icon && <span className={styles.itemIcon}>{item.icon}</span>}
                    <span key={item.key} className={styles.itemText}>
                      {item.text}
                    </span>
                  </a>
                </li>
              ) : (
                <Link key={item.key}>
                  <li>
                    <a href={item.href} className={styles.itemLink}>
                      {item.icon && <span className={styles.itemIcon}>{item.icon}</span>}
                      <span className={styles.itemText}>{item.text}</span>
                    </a>
                  </li>
                </Link>
              )
            })}
        </ul>
      </div>
    )
  }
}

Dropdown.propTypes = {
  text: PropTypes.string,
  heading: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      href: PropTypes.string,
      icon: PropTypes.node,
    }),
  ),
  onClick: PropTypes.func,
}

module.exports = Dropdown
